/* @ngInject */

export default ($rootScope, dateTimeService, Address) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function AssetFinanceVerificationApplicant(
    id,
    idContact,
    identified,
    verificationMethod,
    address,
    dateVerified
  ) {
    this.id = id;
    this.idContact = idContact;
    this.identified = identified;
    this.verificationMethod = verificationMethod;
    this.address = address;
    this.dateVerified = dateVerified;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  AssetFinanceVerificationApplicant.Blank = function (idContact) {
    return AssetFinanceVerificationApplicant.Build({
      id: _.uuid(),
      idContact,
      identified: '',
      verificationMethod: '',
      address: Address.blank(),
      dateVerified: 0
    });
  };
  AssetFinanceVerificationApplicant.Build = function (data) {
    return new AssetFinanceVerificationApplicant(
      data.id ? data.id : _.uuid(),
      data.idContact ? data.idContact : '',
      data.identified ? data.identified : '',
      data.verificationMethod ? data.verificationMethod : '',
      !_.isEmpty(data.address) ? Address.build(data.address) : Address.blank(),
      data.dateVerified ? data.dateVerified : 0
    );
  };

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  AssetFinanceVerificationApplicant.prototype.getAddress = function () {
    return Address.getAddress(this?.address);
  };
  AssetFinanceVerificationApplicant.prototype.getSetDateVerified = function (date) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.dateVerified) {
          this.dateVerifiedObject = '';
        }
        const dateVerifiedObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.dateVerifiedObject = date;
        this.dateVerified = moment.utc(dateVerifiedObject).startOf('day').format('X');
      } else {
        this.dateVerifiedObject = date;
        this.dateVerified = 0;
      }
    }
    if (!this.dateVerifiedObject) {
      if (this.dateVerified) {
        const dateVerifiedObject = dateTimeService.setDate(
          this.dateVerified,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.dateVerifiedObject = dateVerifiedObject;
      } else {
        this.dateVerifiedObject = '';
      }
    }
    return this.dateVerifiedObject;
  };

  return AssetFinanceVerificationApplicant;
};
